/*
 * 作者: 吴松泽
 * 创建时间: 2022-04-28 14:31:26
 * 修改时间: 2022-04-28 14:34:47
 * 版本: [1.0]
 * 版权: 国泰新点软件股份有限公司
 * 描述: sm3加密精简，同时支持小程序环境
 */
import sm3 from 'miniprogram-sm-crypto/src/sm3';
// sm3加密
function sm3Encrypt(data) {
    let encryptData = sm3(data);

    return encryptData;
    // return encryptData.toUpperCase();
}

export default {
    encrypt: sm3Encrypt
};
